$(document).ready(function () {    
    $("#form2").show();
    $("#form3").hide();
    $("#q1").hide();    
    $("#result").hide();
    $("#notifybox").hide();
    $("#notifyboxSuccess").hide();
    $("#successResult").hide();
    var geocoder;
    var map;
    var address = getCookie("Address");

    setCookie("VN", "");
    setCookie("VE", "");
    setCookie("VP", "");

    $('#submit').click(function () {
        var vemail = $("#txtEmail").val();
        if (!validateEmail(vemail)) {
            $('#txtEmail').focus();
            alert("Invalid Email Address");
        }
        else {
            $("#successFormInput").hide();
            $("#successResult").show();
            $("#submit").attr("disabled", "disabled");
            $("#submit").css("background-color", "#E0E0E0");
            $.ajax({                
                url: "/Home/submit",
                type: 'POST',
                cache: false,
                contentType: false,
                processData: false,
                data: "",
                success: function (response) {
                    //alert(response);
                }
            });
        }
    });
    $("#txtName").keyup(
        function () {
            var vname = $("#txtName").val();
            var vemail = $("#txtEmail").val();
            if ((vname != "" && vname != "Name*") && (vemail != "" && vemail != "Email*")) {
                $("#submit").removeAttr("disabled");
            } else {
                $("#submit").attr("disabled", "disabled");
            }
            setCookie("VN", vname);
        }
    );
    $("#txtEmail").keyup(
        function () {
            var vname = $("#txtName").val();
            var vemail = $("#txtEmail").val();
            if ((vname != "" && vname != "Name*") && (vemail != "" && vemail != "Email*")) {
                $("#submit").removeAttr("disabled");
                $("#submit").css("background-color", "#E5B900");

            } else {
                $("#submit").attr("disabled", "disabled");
                $("#submit").css("background-color", "#E0E0E0");
            }
            setCookie("VE", vemail);
        }
    );
    $("#txtPhone").keyup(
        function () {
            var vphone = $("#txtPhone").val();
            setCookie("VP", vphone);
        }
    );
});

var grant = (function () {
    "use strict";

    // Private variables and functions

    // Public methods
    return {
        getValue: function () {
            var sliderValue = $("#ex14").val();
            if (sliderValue == 0) {
                $('#hdnselectedOption').val("no");
                $('#hdnGrantAmt').val("0");
                var value = "Please select your income level";
                $('#selectedtext').text(value);
                $("#continue").attr("disabled", "disabled");
                $("#continue").css("background-color", "#92B9D1");
            }
            else {
                $("#continue").removeAttr("disabled");
                $("#continue").css("background-color", "#2775A3");
            }
            if (sliderValue == 1) {
                $('#hdnselectedOption').val("under");
                // $('#hdnGrantAmt').val("1500");
                $('#hdnGrantAmt').val($('#hdnUnderAmt').val());
                var value = "Less than $" + getCookie("amihalf");
                $('#selectedtext').text(decodeURIComponent(value));
            }
            if (sliderValue == 2) {
                $('#hdnselectedOption').val("between");
                // $('#hdnGrantAmt').val("1000");
                $('#hdnGrantAmt').val($('#hdnBetweenAmt').val());
                var value = "Between $" + getCookie("amihalf") + " and $" + getCookie("ami");
                $('#selectedtext').text(decodeURIComponent(value));
            }
            if (sliderValue == 3) {
                $('#hdnselectedOption').val("above");
                // $('#hdnGrantAmt').val("1000");
                $('#hdnGrantAmt').val($('#hdnAboveAmt').val());
                var value = "Between $" + getCookie("ami") + " and  $" + getCookie("amifull");
                $('#selectedtext').text(decodeURIComponent(value));
            }
            if (sliderValue == 4) {

                $('#hdnselectedOption').val("aboveplus");
                // $('#hdnGrantAmt').val("0");
                $('#hdnGrantAmt').val($('#hdnAbovePlusAmt').val());
                var value = "Over $" + getCookie("amifull");
                $('#selectedtext').text(decodeURIComponent(value));
            }
        },
        showQ1: function () {
            var result = $("#hdnselectedOption").val();
            
            if (result == 'aboveplus' || result == 'above') {
                showResult();
            }
            else {
                $("#form2").hide();
                $("#form3").hide();
                $("#result").hide();
                $("#q1").show();
            }
        },
        showResult: function () {
            $("#form2").hide();
            $("#form3").hide();
            $("#q1").hide();
            
            $("#result").show();

            var result = $("#hdnselectedOption").val();

            if (result == 'under') {
                HideAllQuestions();
                $("#answer").text('Congratulations!');
                $("#additionaltext").text('You qualify for the Freddie Mac HomePossible Grant!');
                var a = parseInt($('#hdnUnderAmt').val()).toLocaleString();
                $("#contacttext").html('Based on the information you’ve provided, you should qualify for <span class="highlight-text">$' + a + '</span> toward downpayment or closing costs.');
                $("#notifybox").hide();
                $("#notifyboxSuccess").show();


                $.ajax({
                    // url: "@Request.ApplicationPath" + "/Home/UnderAMI",
                    url: "/Home/UnderAMI",
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: "",
                    success: function (response) {
                        //alert(response);
                    }
                });

            }
            if (result == 'between') {
                HideAllQuestions();
                $("#answer").text('Congratulations!');
                $("#additionaltext").text('You qualify for the Freddie Mac BorrowSmart Program!');
                var a = parseInt($('#hdnBetweenAmt').val()).toLocaleString();
                $("#contacttext").html('Based on the information you’ve provided, you should qualify for <span class="highlight-text">$' + a + '</span> toward downpayment or closing costs.');
                $("#notifybox").hide();
                $("#notifyboxSuccess").show();


                $.ajax({
                    // url: "@Request.ApplicationPath" + "/Home/BetweenAMI",
                    url: "/Home/BetweenAMI",
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: "",
                    success: function (response) {
                        //alert(response);
                    }
                });

            }
            if (result == 'above') {

                HideAllQuestions();
                $("#answer").html('Sorry, you do not <br />qualify for this program');
                $("#additionaltext").text('But it might be still possible!');
                $("#contacttext").html('We’re sorry, it looks like you may not qualify for this program based on your combined household income, down payment amount and where you are looking to buy.  However, there could be other special conditions that apply to your situation where this program is still possible.<br /><br /> <span class="highlight-text">To investigate further, please take one of the following steps.</span>');
                $("#notifybox").show();
                $("#notifyboxSuccess").hide();
                $.ajax({
                    // url: "@Request.ApplicationPath" + "/Home/OverAMI",
                    url: "/Home/AboveAMI",
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: "",
                    success: function (response) {
                        //alert(response);
                    }
                });

            }
            if (result == 'aboveplus') {

                HideAllQuestions();
                $("#answer").html('Sorry, you do not <br />qualify for this program');
                $("#additionaltext").text('But it might be still possible!');
                $("#contacttext").html('We’re sorry, it looks like you may not qualify for this program based on your combined household income, down payment amount and where you are looking to buy.  However, there could be other special conditions that apply to your situation where this program is still possible.<br /><br /> <span class="highlight-text">To investigate further, please take one of the following steps.</span>');
                $("#notifybox").show();
                $("#notifyboxSuccess").hide();
                $.ajax({
                    // url: "@Request.ApplicationPath" + "/Home/OverAMI",
                    url: "/Home/OverAMI",
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: "",
                    success: function (response) {
                        //alert(response);
                    }
                });
            }
        },
        yesForm3: function () {
            HideAllQuestions();
            $("#answer").text('Congratulations!');
            $("#additionaltext").text('You qualify for the Freddie Mac BorrowSmart program!');
            var a = parseInt($('#hdnAboveAmt').val()).toLocaleString();
            $("#contacttext").html('Based on the information you’ve provided, you should qualify for <span class="highlight-text">$' + a + '</span> toward downpayment or closing costs.');
            $("#notifybox").hide();
            $("#notifyboxSuccess").show();

            $.ajax({                
                url: "/Home/AboveAMI",
                type: 'POST',
                cache: false,
                contentType: false,
                processData: false,
                data: "",
                success: function (response) {
                    //alert(response);
                }
            });
        },
        noForm3: function () {
            HideAllQuestions();
            $("#result").show();
            $("#answer").html('Sorry, you do not <br />qualify for this program');
            $("#additionaltext").text('But it might be still possible!');
            $("#contacttext").html('We’re sorry, it looks like you may not qualify for this program based on your combined household income, down payment amount and where you are looking to buy.  However, there could be other special conditions that apply to your situation where this program is still possible.<br /><br /> <span class="highlight-text">To investigate further, please take one of the following steps.</span>');
            $("#notifybox").show();
            $("#notifyboxSuccess").hide();
            $.ajax({                
                url: "/Home/AboveAMIHomeNotManufactured",
                type: 'POST',
                cache: false,
                contentType: false,
                processData: false,
                data: "",
                success: function (response) {
                    //alert(response);
                }
            });
        },
        validateEmail: function () {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        HideAllQuestions: function () {
            $("#form2").hide();
            $("#form3").hide();
            $("#notifybox").hide();
            $("#q1").hide();
            $("#notifyboxsuccess").hide();
        },
    };
})();

// Make all methods within cookieJavascript globally accessible
Object.keys(grant).forEach(function (key) {
    window[key] = grant[key];
});









